import { useParams } from 'react-router-dom'
import * as React from 'react'
import { createContext, useContext } from 'react'
import { UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'
import { useStuartGet } from '../../../APIs/Hooks/PhpAPIHooks'
import { tsScreen } from '../../../Typescript/DB_Interface'
import { useUserContext } from '../../UserConfig'

interface StudyContextInterface {
  screenQuery: UseQueryResult<tsScreen, AxiosResponse<any, any>>
  editable: boolean
}

const ScreenContext = createContext<StudyContextInterface>(
  {} as StudyContextInterface,
)
export const useScreenContext = () => useContext(ScreenContext)

function SelectedScreenModule({ children }: { children: any }) {
  const { screen_id } = useParams()
  const { loginConfig } = useUserContext()
  const screenQuery = useStuartGet(
    ['/screen/getScreen.php', `?ScreenID=${screen_id}&Samples=Y`],
    !!screen_id,
  )
  return (
    <ScreenContext.Provider
      value={{
        screenQuery,
        editable:
          screenQuery.data?.CollectionStatus === 'DFT' &&
          !!loginConfig?.Modules?.EditScreenRequest,
      }}
    >
      {children}
    </ScreenContext.Provider>
  )
}

export default SelectedScreenModule
